export const goalFields = [
	{
		name: "protein_calories",
		label: "Protein calories",
		step: 1
	},
	{
		name: "vegetable",
		label: "Vegetable",
		step: 0.1
	},
	{
		name: "fruits",
		label: "Fruits",
		step: 0.1
	},

	{
		name: "fat",
		label: "Fat",
		step: 0.1
	},

	{
		name: "misc",
		label: "Misc",
		step: 1
	},

	{
		name: "starch",
		label: "Starch",
		step: 0.1
	},

	{
		name: "dairy",
		label: "Dairy",
		step: 0.1
	},
	{
		name: "hydration",
		label: "Hydration",
		step: 1
	},
	{
		name: "electrolyte",
		label: "Electrolyte",
		step: 1
	},
	{
		name: "calories",
		label: "Calories",
		step: 1
	}
];
